import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import BasicInputField from './fields/BasicInputField';
import { BodyText, CaptionText } from '@paypalcorp/pp-react';
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react';
import { MessageFormat } from '@paypalcorp/worldready';
import { trackEventWithData } from '../utilsV3/analytics';
import { FPTI_SPEC } from '../utilsV3/fptiConstants';
import _ from 'lodash';

const renderTextField = (props) => {
  const updatedProps = _.merge({ input: { tabIndex: 1 } }, props);
  return <BasicInputField {...updatedProps} />;
};

renderTextField.propTypes = {
  input: PropTypes.object,
};

function ButtonName() {
  const worldReady = useContext(WorldReadyContext);

  useEffect(() => {
    trackEventWithData(FPTI_SPEC.DONATE_SETUP_WIZARD_PROJECT_NAME_SHOWN);
  }, []);

  return (
    <div className="button-name">
      <BodyText strong className="label">
        <Message id="buttonsV3.buttonName.title" />
      </BodyText>
      <CaptionText className="helper-text">
        <Message id="buttonsV3.buttonName.helperText" />
      </CaptionText>
      <Field
        id="buttonName"
        name="buttonName"
        type="text"
        component={renderTextField}
        label={new MessageFormat(worldReady, {
          id: 'buttonsV3.buttonName.label',
        }).format()}
        validateOnChange={true}
      />
    </div>
  );
}

export default ButtonName;
